import SearchInput from './SearchInput'

export default SearchInput



// WEBPACK FOOTER //
// ./src/legacy/components/SearchInput/index.js